import gsap from "gsap/gsap-core";
import Sine from 'gsap';
import { handleDetailClick } from './handleDetails';
import { removeBlur } from "./handleLazyImages";
import imagesLoaded from 'imagesloaded';

let currentImage = 0;
const duration = 0.6;
const offset = 0.2;
const moveBy = window.innerWidth / 40;
let arrowClickActive = true;

export function initiateSlideshow(logoLoad, logoHome, logoArrow) {
    const firstImage = document.querySelector('.image_gallery_container:first-child');
    if (firstImage) {
        firstImage.classList.add('show');
        gsap.to(firstImage, {
            opacity: 1,
        })
    }
    const logo = document.querySelector('.logo');
    if(logo){
        gsap.to(logo, {
            zIndex: -3000
        })
    }
    logoArrow?.remove();

    const closeStripes = document.querySelector('.close_stripes');
    if(closeStripes !== null){
        closeStripes.addEventListener('click', (event) => {checkandgo(event)});
    }
}

function updateArrow(event, arrow) {
    const xCoord = event.clientX;
    const yCoord = event.clientY;

    const width = arrow.clientWidth;
    const height = arrow.clientHeight;
    if(arrow){
        if (xCoord > (window.innerWidth / 2)) {
            gsap.to(arrow,
                {
                    transform: 'scaleX(1)',
                    left: xCoord - width,
                    top: yCoord - height / 2,
                    duration: 0.1,
                    ease: Sine.easeOut,
                    onComplete: function () {
                        !arrow.classList.contains('show_arrow') && arrow.classList.add('show_arrow');
                    }
                })
        }
        else {
            gsap.to(arrow,
                {
                    transform: 'scaleX(-1)',
                    left: xCoord,
                    top: yCoord - height / 2,
                    duration: 0.1,
                    ease: Sine.easeOut,
                    onComplete: function () {
                        !arrow.classList.contains('show_arrow') && arrow.classList.add('show_arrow');
                    }
                })
        }
    }  
}

export function handleSlideshow(event, images) {
    const xCoord = event.clientX;
    const yCoord = event.clientY;
    let prevImage = null;
    let showImage = null;
    let transform = '';
    if (arrowClickActive) {
        if (!(xCoord >= window.innerWidth * 0.8 && (yCoord >= window.innerHeight * 0.8 || yCoord <= window.innerHeight * 0.2))) {
            arrowClickActive = false;
            if (xCoord > window.innerWidth / 2) {
                if (currentImage < images.length - 1) {
                    prevImage = images[currentImage];
                    currentImage++;
                    showImage = images[currentImage];
                    transform = -moveBy;
                } else {
                    arrowClickActive = true;
                }
            } else {
                if (currentImage >= 1) {
                    prevImage = images[currentImage];
                    currentImage--;
                    showImage = images[currentImage];
                    transform = moveBy;
                } else {
                    arrowClickActive = true;
                }
            }

            const timelineSlide = gsap.timeline();
            if (prevImage !== null && showImage !== null) {
                timelineSlide.to(
                    prevImage, {
                    duration: duration,
                    x: transform,
                    opacity: 0,
                    ease: Sine.easeOut,
                });
                timelineSlide.to(
                    showImage, {
                    duration: 0.01,
                    x: -transform,
                    opacity: 0,
                    ease: Sine.easeOut,
                    onComplete: function () {
                        arrowClickActive = true;
                    }
                });
                timelineSlide.to(
                    showImage, {
                    duration: duration,
                    transform: 'matrix(1,0,0,1,0,0)',
                    opacity: 1,
                    ease: Sine.easeOut,
                })
            }
        }
    }

}

const arrowIntersections = function (elements, arrow) {
    const menuContainer = document.getElementById('menu_container');
    menuContainer?.addEventListener('mouseenter', () => {
        arrow?.classList.add('hidden');
    });
    menuContainer?.addEventListener('mouseleave', () => {
        arrow?.classList.remove('hidden');
    })
    elements.forEach(
        element => {
            if(element){
                element?.addEventListener('mouseenter', () => {
                    arrow?.classList.add('less_visible');
                })
                element?.addEventListener('mouseleave', () => {
                    arrow?.classList.remove('less_visible')
                })
            }
        }
    )
}

function checkandgo(event){
    if(window.history.length > 1){
        event.preventDefault();
        window.history.back();
    }
}

export const handleSlideshowContainer = function (slideShowContainer, phone) {
    const slideShowImages = Array.from(document.querySelectorAll('.image_gallery_container'));
    const arrow = document.querySelector('#arrow_container');
    const detailsButton = document.querySelector('.project-details_details');
    const closeButton = document.querySelector('.project-details_close');
    const detailsText = document.querySelector('.project-details_text');
    const closeStripes = document.querySelector('.close_stripes');
    arrowIntersections([closeButton, detailsButton, detailsText, closeStripes], arrow);

    const images = Array.from(document.querySelectorAll('img'));
    if (images) {
        images.forEach(
            image => imagesLoaded(image, removeBlur)
        )
    }

    if (detailsButton && closeButton && detailsText) {
        detailsButton.addEventListener('click', () => handleDetailClick(detailsButton, closeButton, detailsText, true));
        closeButton.addEventListener('click', () => handleDetailClick(detailsButton, closeButton, detailsText, false));
    }
    slideShowContainer?.addEventListener('click', (event) => { handleSlideshow(event, slideShowImages) });
    if (phone) {
        if (arrow !== null) {
            arrow.remove();
        }
    } else {
        if (arrow !== null) {
            slideShowContainer?.addEventListener('mousemove', _.debounce((event) => { updateArrow(event, arrow) }, 3));
        }
    }
}